import Immutable from 'immutable';
import {
  FLAG_GETTING_EXPECTED_FUEL_CONSUMPTIONS,
  GET_EXPECTED_FUEL_CONSUMPTIONS,
  CLEAR_EXPECTED_FUEL_CONSUMPTIONS,
  FLAG_EXPECTED_FUEL_CONSUMPTION_ACTIVITY,
  GET_EXPECTED_FUEL_CONSUMPTION,
  CLEAR_EXPECTED_FUEL_CONSUMPTION,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_EXPECTED_FUEL_CONSUMPTIONS:
      return state.setIn(['all', 'loading'], payload);
    case GET_EXPECTED_FUEL_CONSUMPTIONS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_EXPECTED_FUEL_CONSUMPTIONS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_EXPECTED_FUEL_CONSUMPTION_ACTIVITY:
      // raising flag
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      // lowering flag
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_EXPECTED_FUEL_CONSUMPTION:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_EXPECTED_FUEL_CONSUMPTION:
      return state.setIn(
        ['current', 'content'],
        INITIAL_STATE.getIn(['current', 'content']),
      );
    default:
      return state;
  }
};
